<script setup>
import { useI18n } from 'vue-i18n'
import { useSessionData } from '@/core/composables/useSessionData'

const { t } = useI18n()
const { sessionData } = useSessionData()
const { r } = useRoutes()

const profiles = sessionData?.profiles
const activeProfile = profiles?.find(profile => profile.selected)

const generalItems = [
  ...(profiles.some(profile => profile.type === 'provider')
    ? [{
        id: 1,
        label: t('New Business Account'),
        icon: 'i-fas-plus',
        url: '/add_business/',
      }]
    : []),
  {
    id: 2,
    label: t('Logout'),
    icon: 'i-fas-right-from-bracket',
    url: r({ path: '/logout/', isV2Path: false, applyCurrentProviderPrefix: false }),
  },
]
</script>

<template>
  <div class="profile-switcher truncate">
    <DSDropdown
      class="max-w-full rounded-md bg-white px-4 py-2 text-xs text-secondary font-medium hover:bg-secondary-100 hover:bg-opacity-75"
      menu-items-classes="right-0 rounded-10px"
      omit-position-relative
      placement="bottom-end"
    >
      <template #label>
        {{ activeProfile?.name }}
      </template>
      <template #default>
        <div class="p-2">
          <div class="profile-switcher-list max-h-400px overflow-auto">
            <AppProfileSwitcherAccountItem
              v-for="profile in profiles"
              :key="profile.id"
              :profile="profile"
              :is-active="profile.id === activeProfile?.id"
            />
          </div>
          <div class="profile-switcher-list">
            <AppProfileSwitcherItem
              v-for="item in generalItems"
              :key="item.label"
              :item="item"
            />
          </div>
        </div>
      </template>
    </DSDropdown>
  </div>
</template>

<style scoped lang="scss">
.profile-switcher {
  :deep(.base-dropdown-button) {
    &.open {
      @apply bg-secondary text-text-100;
    }
  }
  .profile-switcher-list {
    > * {
      &:first-child {
        @apply mt-0;
      }
      &:last-child {
        @apply mb-0;
      }
    }
  }
}
</style>

<i18n>
{
  "en-us": {
    "Logout": "Logout",
    "New Business Account": "New Business Account",
    "Setup Guide": "Setup Guide"
  }
}
</i18n>

<i18n locale="de" lang="json">
{
  "Logout": "Abmelden",
  "New Business Account": "Neues Unternehmenskonto",
  "Setup Guide": "Set-up-Anleitung"
}
</i18n>

<i18n locale="fr" lang="json">
{
  "Logout": "Déconnexion",
  "Setup Guide": "Guide d'installation",
  "New Business Account": "Nouveau compte d'affaires"
}
</i18n>

<i18n locale="es" lang="json">
{
  "Logout": "Cerrar sesión",
  "New Business Account": "Nueva cuenta de empresa",
  "Setup Guide": "Guía de configuración"
}
</i18n>
